import React from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function SearchBar({ searchTerm, setSearchTerm }) {
  return (
    <InputGroup>
   <InputGroup.Text className="hide-on-mobile">
        <FontAwesomeIcon icon={faSearch} />
      </InputGroup.Text>
    <FormControl
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="custom-input"
    />
</InputGroup>
  );
}
export default SearchBar;
